
import { motion } from "framer-motion";
import { Bot, Zap, Clock, LineChart, Shield, Code } from "lucide-react";

export const AIAdvantages = () => {
  const advantages = [
    {
      icon: Bot,
      title: "AI-Powered Development",
      description: "Our developers leverage specialized AI tooling for faster, more accurate code generation and testing."
    },
    {
      icon: Clock,
      title: "70% Faster Delivery",
      description: "AI acceleration reduces development cycles dramatically without sacrificing quality."
    },
    {
      icon: LineChart,
      title: "Enhanced Precision",
      description: "AI-assisted code reviews catch 95% more potential issues before they become problems."
    },
    {
      icon: Shield,
      title: "Proactive Security",
      description: "AI continuously monitors for vulnerabilities and suggests security improvements."
    },
    {
      icon: Code,
      title: "Smart Optimization",
      description: "Automated performance tuning ensures your application runs at peak efficiency."
    },
    {
      icon: Zap,
      title: "Intelligent Scaling",
      description: "AI predictive models prepare your system for growth before you need it."
    }
  ];
  
  return (
    <div className="min-h-screen flex flex-col justify-center py-16 px-8">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="inline-block px-4 py-1 bg-brand-orange/10 text-brand-orange rounded-full text-sm font-mono mb-4">
            Human + AI Collaboration
          </span>
          
          <h2 className="text-4xl md:text-6xl font-display font-bold mb-6 text-white">
            AI-Augmented Development <span className="text-brand-orange">Advantages</span>
          </h2>
          
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            We combine human creativity with AI efficiency to deliver software that exceeds expectations in record time.
          </p>
        </motion.div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {advantages.map((advantage, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 + index * 0.1 }}
              className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-6 hover:bg-white/10 transition-colors group"
            >
              <div className="w-12 h-12 bg-brand-orange/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-brand-orange/20 transition-colors">
                <advantage.icon className="w-6 h-6 text-brand-orange" />
              </div>
              
              <h3 className="text-xl font-bold text-white mb-2">{advantage.title}</h3>
              <p className="text-gray-400">{advantage.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};
